(() => {
	const scriptElement = document.querySelector('script[data-lashuma-search]');
	const lexiconUrl = scriptElement ? scriptElement.dataset.lexiconUrl : '';

	let LASHUMA_SEARCH_CATALOG = null;
	let KNOWN_DIMENSIONS_BY_AREA = new Map();
	let DYNAMIC_COLOR_SOURCE = null;

	/*
	 * TESTVERSION V8: Farben werden NICHT aus dem Metaobjekt-Suchlexikon gelesen.
	 * Einzige Farbquelle ist das automatisch gepflegte Produktmetafeld:
	 *
	 * custom.such_farben  (Liste -> Einzeiliger Text)
	 *
	 * Die vier Ursprungs-Farbfelder und das Feld für manuell ergänzte Suchfarben
	 * werden ausschließlich durch Shopify Flow zu custom.such_farben zusammengeführt.
	 * Die JS muss diese Ursprungsfelder deshalb nicht mehr kennen.
	 *
	 * Für die Erkennung der aktuell vorhandenen Farbwerte liest die JS den von
	 * Shopify gerenderten Storefront-Filter auf /collections/all aus. Voraussetzung:
	 * custom.such_farben ist in Search & Discovery als Filter aktiviert.
	 * WICHTIG: Der technische Filter darf im Theme unsichtbar sein, muss aber
	 * weiterhin im HTML gerendert werden, damit diese JS seine Werte auslesen kann.
	 *
	 * V8: Exakte Farbnamen haben Vorrang vor abgeleiteten Teil-Aliasen.
	 * "Grün" bleibt daher Grün und wird nicht mehr zu "Blau - Grün".
	 */
	const DYNAMIC_COLOR_FILTER_NAME = 'filter.p.m.custom.such_farben';
	const DYNAMIC_COLOR_SOURCE_URL = '/collections/all';

	function asStringArray(value) {
		if (Array.isArray(value)) {
			return value
				.map(item => String(item).trim())
				.filter(Boolean);
		}

		if (typeof value === 'string' && value.trim()) {
			try {
				const parsed = JSON.parse(value);

				if (Array.isArray(parsed)) {
					return parsed
						.map(item => String(item).trim())
						.filter(Boolean);
				}
			} catch (error) {
				// Einzelwert als Fallback weiterverwenden.
			}

			return [value.trim()];
		}

		return [];
	}


	function normalizeArea(value) {
		const normalized = String(value || '')
			.trim()
			.toLowerCase();

		if (normalized === 'textil') return 'textil';
		if (normalized === 'keramik') return 'keramik';

		return 'alle';
	}

	function getEntryArea(entry) {
		return normalizeArea(
			entry && (entry.area || entry.bereich)
		);
	}

	function addActiveArea(activeAreas, entry) {
		const area = getEntryArea(entry);

		if (area !== 'alle') {
			activeAreas.add(area);
		}
	}

	function entryMatchesActiveArea(entry, activeAreas) {
		const area = getEntryArea(entry);

		if (area === 'alle') {
			return true;
		}

		if (!activeAreas.size) {
			return true;
		}

		if (activeAreas.size > 1) {
			return false;
		}

		return activeAreas.has(area);
	}

	function buildCatalogFromMetaobjects(entries) {
		const catalog = {
			product_types: [],
			colors: [],
			color_shades: [],
			motifs: [],
			series: [],
			broad_terms: [],
			personalization: [],
			stop_words: []
		};

		(entries || []).forEach(rawEntry => {
			const category = String(rawEntry.kategorie || '').trim();
			const label = String(rawEntry.bezeichnung || '').trim();

			/* Farben kommen in dieser Testversion ausschließlich aus Produktmetafeldern. */
			if (category === 'Grundfarbe' || category === 'Farbton') {
				return;
			}
			const aliases = asStringArray(rawEntry.kundeneingaben);
			const searchValues = asStringArray(rawEntry.shopify_suchbegriffe);
			const strictSingle = rawEntry.strenge_suche === true || rawEntry.strenge_suche === 'true';

			if (!category || !aliases.length) return;

			if (category === 'Stoppwort') {
				catalog.stop_words.push(...aliases);
				return;
			}

			const entry = {
				key: rawEntry.handle || label || aliases[0],
				aliases: aliases,
				strict_single: strictSingle,
				area: normalizeArea(rawEntry.bereich)
			};

			if (category === 'Serie') {
				if (!label) return;

				entry.filters = [
					{
						name: 'filter.p.m.theme.sibling_serie',
						values: [label]
					}
				];
			} else if (searchValues.length) {
				entry.search = [
					{
						field: 'title',
						values: searchValues
					}
				];
			}

			switch (category) {
				case 'Produktart':
					catalog.product_types.push(entry);
					break;
				case 'Motiv':
					catalog.motifs.push(entry);
					break;
				case 'Serie':
					catalog.series.push(entry);
					break;
				case 'Größenbegriff':
					catalog.broad_terms.push(entry);
					break;
				case 'Personalisierung':
					catalog.personalization.push(entry);
					break;
				default:
					console.warn(`Unbekannte Lashuma-Suchkategorie: ${category}`);
			}
		});

		catalog.stop_words = [...new Set(catalog.stop_words)];

		return catalog;
	}

	function loadCatalogFromMetaobjects() {
		const dataElement = document.querySelector('[data-lashuma-search-metaobjects]');

		if (!dataElement) {
			return null;
		}

		const entries = JSON.parse(dataElement.textContent || '[]');

		if (!Array.isArray(entries) || !entries.length) {
			return null;
		}

		return buildCatalogFromMetaobjects(entries);
	}

	async function loadLegacyCatalog(url) {
		const response = await fetch(url);

		if (!response.ok) {
			throw new Error(`Lashuma JSON-Suchlexikon konnte nicht geladen werden: ${response.status}`);
		}

		return response.json();
	}


	function adjectiveAliases(value) {
		const cleanValue = String(value || '').trim();
		const normalized = normalizeLookup(cleanValue);
		const aliases = new Set([cleanValue]);

		/* blau -> blaue/blauer/blaues/blauen/blauem, weiß -> weiße/... */
		if (normalized && !normalized.includes(' ') && !normalized.includes('-')) {
			if (normalized.endsWith('e')) {
				aliases.add(`${normalized}s`);
				aliases.add(`${normalized}r`);
				aliases.add(`${normalized}n`);
				aliases.add(`${normalized}m`);
			} else {
				aliases.add(`${normalized}e`);
				aliases.add(`${normalized}er`);
				aliases.add(`${normalized}es`);
				aliases.add(`${normalized}en`);
				aliases.add(`${normalized}em`);
			}
		}

		return [...aliases];
	}

	function dynamicColorAliases(value, exactColorValues) {
		const cleanValue = String(value || '').trim();
		const aliases = new Set(adjectiveAliases(cleanValue));
		const parts = cleanValue
			.split(/\s*[-–—]\s*/)
			.map(part => part.trim())
			.filter(Boolean);

		/*
		 * Zusammengesetzte Farben dürfen einen einfachen Farbwert nicht verdrängen.
		 * Beispiel: Wenn "Grün" als eigener Such-Farben-Wert existiert, darf
		 * "Blau - Grün" NICHT zusätzlich den Alias "Grün" erhalten.
		 * Existiert der Teilwert nicht separat (z. B. "Aprikosen"), bleibt er
		 * als hilfreicher Alias für "Gelb - Aprikosen" erhalten.
		 */
		if (parts.length > 1) {
			const derivedValue = parts[parts.length - 1];
			const derivedKey = normalizeLookup(derivedValue);

			if (!exactColorValues || !exactColorValues.has(derivedKey)) {
				adjectiveAliases(derivedValue).forEach(alias => aliases.add(alias));
			}
		}

		return [...aliases];
	}

	function extractSearchColorValues(doc) {
		const values = [];
		const selector = `input[name="${DYNAMIC_COLOR_FILTER_NAME}"]`;

		doc.querySelectorAll(selector).forEach(input => {
			const value = String(input.value || '').trim();
			if (value && !values.includes(value)) values.push(value);
		});

		return values;
	}

	function makeDynamicColorEntry(value, exactColorValues) {
		return {
			key: `metafield:${DYNAMIC_COLOR_FILTER_NAME}:${value}`,
			aliases: dynamicColorAliases(value, exactColorValues),
			strict_single: true,
			area: 'alle',
			filters: [{ name: DYNAMIC_COLOR_FILTER_NAME, values: [value] }],
			source: 'product_metafield',
			metafield_key: 'custom.such_farben',
			metafield_value: value
		};
	}

	async function loadDynamicColorsFromSearchMetafield() {
		const response = await fetch(DYNAMIC_COLOR_SOURCE_URL, {
			credentials: 'same-origin',
			headers: { 'X-Requested-With': 'LashumaSearchColorCatalog' }
		});

		if (!response.ok) {
			throw new Error(`Dynamische Farbquelle konnte nicht geladen werden: ${response.status}`);
		}

		const html = await response.text();
		const doc = new DOMParser().parseFromString(html, 'text/html');
		const values = extractSearchColorValues(doc);

		DYNAMIC_COLOR_SOURCE = {
			url: DYNAMIC_COLOR_SOURCE_URL,
			filter_name: DYNAMIC_COLOR_FILTER_NAME,
			metafield_key: 'custom.such_farben',
			values: [...values]
		};

		if (!values.length) {
			throw new Error(
				'Keine Werte für custom.such_farben gefunden. Bitte Such-Farben in Shopify Search & Discovery als Storefront-Filter aktivieren und prüfen, ob Produkte bereits befüllt sind.'
			);
		}

		const exactColorValues = new Set(
			values.map(value => normalizeLookup(value))
		);

		return values.map(value => makeDynamicColorEntry(value, exactColorValues));
	}

	function collectKnownDimensionsByArea(catalog) {
		const dimensionsByArea = new Map();

		function ensureArea(area) {
			if (!dimensionsByArea.has(area)) {
				dimensionsByArea.set(area, new Set());
			}

			return dimensionsByArea.get(area);
		}

		(catalog && catalog.broad_terms || []).forEach(entry => {
			const area = getEntryArea(entry);
			const dimensions = ensureArea(area);

			(entry.search || []).forEach(definition => {
				(definition.values || []).forEach(value => {
					const normalized = String(value)
						.toLowerCase()
						.replace(/\s+/g, '');

					if (/^\d{1,3}x\d{1,3}$/.test(normalized)) {
						dimensions.add(normalized);
					}
				});
			});
		});

		return dimensionsByArea;
	}

	function dimensionExistsForAreas(dimension, activeAreas) {
		if (activeAreas.size > 1) {
			const globalDimensions = KNOWN_DIMENSIONS_BY_AREA.get('alle');
			return Boolean(globalDimensions && globalDimensions.has(dimension));
		}

		if (activeAreas.size === 1) {
			const area = [...activeAreas][0];
			const areaDimensions = KNOWN_DIMENSIONS_BY_AREA.get(area);
			const globalDimensions = KNOWN_DIMENSIONS_BY_AREA.get('alle');

			return Boolean(
				(areaDimensions && areaDimensions.has(dimension)) ||
				(globalDimensions && globalDimensions.has(dimension))
			);
		}

		for (const dimensions of KNOWN_DIMENSIONS_BY_AREA.values()) {
			if (dimensions.has(dimension)) {
				return true;
			}
		}

		return false;
	}

	function resolveKnownDimension(first, second, activeAreas) {
		const direct = `${first}x${second}`;
		const reversed = `${second}x${first}`;

		if (dimensionExistsForAreas(direct, activeAreas)) {
			return direct;
		}

		if (dimensionExistsForAreas(reversed, activeAreas)) {
			return reversed;
		}

		return '';
	}

	const lexiconPromise = (async () => {
		let catalog = null;

		try {
			catalog = loadCatalogFromMetaobjects();
		} catch (error) {
			console.warn('Lashuma Metaobjekt-Suchlexikon konnte nicht gelesen werden:', error);
		}

		if (!catalog && lexiconUrl) {
			try {
				catalog = await loadLegacyCatalog(lexiconUrl);
			} catch (error) {
				console.error(error);
			}
		}

		if (catalog) {
			/* Keine Farben aus Metaobjekt oder Legacy-JSON übernehmen. */
			catalog.colors = [];
			catalog.color_shades = [];

			try {
				catalog.colors = await loadDynamicColorsFromSearchMetafield();
				catalog.color_shades = [];
			} catch (error) {
				console.warn('Lashuma Such-Farben konnten nicht geladen werden:', error);
			}
		}

		LASHUMA_SEARCH_CATALOG = catalog;
		KNOWN_DIMENSIONS_BY_AREA = collectKnownDimensionsByArea(catalog);

		return catalog;
	})();

	function normalizeDimensions(query) {
		return query
			.replace(/(\d{1,3})\s*[x×X*]\s*(\d{1,3})\s*cm\b/gi, '$1x$2')
			.replace(/(\d{1,3})\s*[x×X*]\s*(\d{1,3})/g, '$1x$2');
	}

	function normalizeVisibleQuery(query) {
		return query
			.replace(/\s+/g, ' ')
			.trim();
	}

	function normalizeLookup(query) {
		return normalizeDimensions(normalizeVisibleQuery(query))
			.toLowerCase()
			.replace(/ä/g, 'ae')
			.replace(/ö/g, 'oe')
			.replace(/ü/g, 'ue')
			.replace(/ß/g, 'ss')
			.replace(/[-_/]+/g, ' ')
			.replace(/[.,;!?()[\]{}"']/g, ' ')
			.replace(/\s+/g, ' ')
			.trim();
	}

	function escapeRegExp(value) {
		return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}

	function aliasPattern(alias) {
		const normalizedAlias = normalizeLookup(alias);
		const pattern = escapeRegExp(normalizedAlias).replace(/\s+/g, '\\s+');

		return new RegExp(`(^|\\s)${pattern}(?=\\s|$)`, 'i');
	}

	function rawAliasPattern(alias) {
		const pattern = escapeRegExp(alias.trim()).replace(/\s+/g, '\\s+');

		return new RegExp(`(^|\\s)${pattern}(?=\\s|$)`, 'iu');
	}

	function consumeEntry(query, entry) {
		const aliases = [...entry.aliases]
			.sort((a, b) => normalizeLookup(b).length - normalizeLookup(a).length);

		let workingQuery = query;
		let matched = false;

		aliases.forEach(alias => {
			const pattern = aliasPattern(alias);

			if (pattern.test(workingQuery)) {
				workingQuery = workingQuery.replace(pattern, ' ');
				matched = true;
			}
		});

		return {
			query: workingQuery.replace(/\s+/g, ' ').trim(),
			matched: matched
		};
	}

	function removeEntriesFromVisibleQuery(query, entries) {
		let result = query;

		entries.forEach(entry => {
			const aliases = [...entry.aliases]
				.sort((a, b) => b.length - a.length);

			aliases.forEach(alias => {
				result = result.replace(rawAliasPattern(alias), ' ');
			});
		});

		return result
			.replace(/\s+/g, ' ')
			.trim();
	}

	function shopifyValue(value) {
		const escaped = value
			.replace(/\\/g, '\\\\')
			.replace(/"/g, '\\"');

		if (/\s/.test(escaped)) {
			return `"${escaped}"`;
		}

		return escaped;
	}

	function buildFieldClause(field, values) {
		const uniqueValues = [...new Set(values)];

		if (uniqueValues.length === 1) {
			return `${field}:${shopifyValue(uniqueValues[0])}`;
		}

		return `(${uniqueValues.map(value => `${field}:${shopifyValue(value)}`).join(' OR ')})`;
	}

	function buildSearchClause(searchDefinitions) {
		const clauses = [];

		(searchDefinitions || []).forEach(definition => {
			if (
				definition.field &&
				Array.isArray(definition.values) &&
				definition.values.length
			) {
				clauses.push(
					buildFieldClause(definition.field, definition.values)
				);
			}
		});

		if (!clauses.length) {
			return '';
		}

		if (clauses.length === 1) {
			return clauses[0];
		}

		return `(${clauses.join(' OR ')})`;
	}

	function removeStopWords(query) {
		if (!LASHUMA_SEARCH_CATALOG) return query;

		const stopWords = new Set(
			(LASHUMA_SEARCH_CATALOG.stop_words || []).map(word => normalizeLookup(word))
		);

		return query
			.split(' ')
			.filter(word => word && !stopWords.has(word))
			.join(' ')
			.trim();
	}

	function sortEntriesByAliasLength(entries) {
		return [...entries].sort((a, b) => {
			const aLength = Math.max(...a.aliases.map(alias => normalizeLookup(alias).length));
			const bLength = Math.max(...b.aliases.map(alias => normalizeLookup(alias).length));

			return bLength - aLength;
		});
	}

	function isGenericHandtuchEntry(entry) {
		const aliases = (entry && entry.aliases || [])
			.map(value => normalizeLookup(value));
		const searchValues = [];

		(entry && entry.search || []).forEach(definition => {
			(definition.values || []).forEach(value => {
				searchValues.push(normalizeLookup(value));
			});
		});

		return (
			aliases.includes('handtuch') ||
			searchValues.includes('handtuch')
		);
	}

	function getEffectiveProductEntries(entries) {
		const hasSpecificTextileProduct = (entries || []).some(entry => {
			return (
				getEntryArea(entry) === 'textil' &&
				!isGenericHandtuchEntry(entry)
			);
		});

		if (!hasSpecificTextileProduct) {
			return entries || [];
		}

		return (entries || []).filter(entry => {
			return !(
				getEntryArea(entry) === 'textil' &&
				isGenericHandtuchEntry(entry)
			);
		});
	}

	function analyseSearchQuery(rawQuery) {
		const visibleQuery = normalizeVisibleQuery(rawQuery);

		if (!visibleQuery) {
			return {
				visible_query: '',
				shopify_query: '',
				filters: [],
				mode: 'empty'
			};
		}

		if (!LASHUMA_SEARCH_CATALOG) {
			return {
				visible_query: visibleQuery,
				shopify_query: visibleQuery,
				filters: [],
				mode: 'normal'
			};
		}

		let workingQuery = normalizeLookup(visibleQuery);

		const clauses = [];
		const personalizationClauses = [];
		const filters = [];
		const matchedEntries = [];
		const matchedFilterEntries = [];
		const matchedPersonalizationEntries = [];
		const matchedProductEntries = [];
		const matchedContextKinds = new Set();
		const activeAreas = new Set();

		/*
		 * Zuerst Begriffe erkennen, die den Bereich bestimmen können.
		 * Größen werden erst danach verarbeitet.
		 */
		const contextGroups = [
			{
				kind: 'series',
				entries: LASHUMA_SEARCH_CATALOG.series || []
			},
			{
				kind: 'product',
				entries: LASHUMA_SEARCH_CATALOG.product_types || []
			},
			{
				kind: 'personalization',
				entries: LASHUMA_SEARCH_CATALOG.personalization || []
			},
			{
				kind: 'color',
				entries: LASHUMA_SEARCH_CATALOG.color_shades || []
			},
			{
				kind: 'color',
				entries: LASHUMA_SEARCH_CATALOG.colors || []
			},
			{
				kind: 'motif',
				entries: LASHUMA_SEARCH_CATALOG.motifs || []
			}
		];

		contextGroups.forEach(group => {
			sortEntriesByAliasLength(group.entries).forEach(entry => {
				/*
				 * Wenn bereits ein eindeutiger Bereich erkannt wurde, werden
				 * Einträge aus einem anderen Bereich nicht konsumiert.
				 * Beispiel: "Butterdose personalisiert" bleibt dadurch eine
				 * normale Suche und springt nicht in den Textil-Personalisierungsmodus.
				 */
				if (!entryMatchesActiveArea(entry, activeAreas)) {
					return;
				}

				const result = consumeEntry(workingQuery, entry);

				if (!result.matched) return;

				workingQuery = result.query;
				matchedEntries.push(entry);
				matchedContextKinds.add(group.kind);
				addActiveArea(activeAreas, entry);

				if (group.kind === 'personalization') {
					matchedPersonalizationEntries.push(entry);
				}

				if (group.kind === 'product') {
					/*
					 * Produktarten werden erst nach der Erkennung ausgewertet.
					 * So kann ein allgemeines "Handtuch" verworfen werden, wenn
					 * gleichzeitig eine spezifische Textil-Produktart erkannt wurde.
					 */
					matchedProductEntries.push(entry);
				} else {
					const clause = buildSearchClause(entry.search);

					if (clause) {
						clauses.push(clause);

						if (group.kind === 'personalization') {
							personalizationClauses.push(clause);
						}
					}
				}

				if (Array.isArray(entry.filters) && entry.filters.length) {
					matchedFilterEntries.push(entry);

					entry.filters.forEach(filter => {
						if (
							filter.name &&
							Array.isArray(filter.values) &&
							filter.values.length
						) {
							filters.push({
								name: filter.name,
								values: [...filter.values]
							});
						}
					});
				}
			});
		});

		/*
		 * Wenn eine spezifische Textil-Produktart erkannt wurde, darf das allgemeine
		 * "Handtuch" nicht zusätzlich per AND eingeschränkt werden.
		 * Beispiel: "Handtuch für die Küche" -> nur Küchenhandtuch.
		 */
		getEffectiveProductEntries(matchedProductEntries).forEach(entry => {
			const clause = buildSearchClause(entry.search);

			if (clause) {
				clauses.push(clause);
			}
		});

		/*
		 * Numerische Größen nur verwenden, wenn sie im aktiven Bereich bekannt sind.
		 */
		workingQuery = workingQuery.replace(
			/\b(\d{1,3})x(\d{1,3})\b/g,
			(match, first, second) => {
				const dimension = resolveKnownDimension(
					first,
					second,
					activeAreas
				);

				if (!dimension) {
					return match;
				}

				clauses.push(
					buildFieldClause('title', [dimension])
				);

				matchedEntries.push({
					key: dimension,
					strict_single: true,
					area: activeAreas.size === 1
						? [...activeAreas][0]
						: 'alle'
				});

				return ' ';
			}
		);

		workingQuery = workingQuery
			.replace(/\s+/g, ' ')
			.trim();

		/*
		 * Breite Größenbegriffe wie XXL, groß, klein oder lang werden erst jetzt
		 * verarbeitet und nur, wenn ihr Bereich zur Suchanfrage passt.
		 */
		sortEntriesByAliasLength(
			LASHUMA_SEARCH_CATALOG.broad_terms || []
		).forEach(entry => {
			if (!entryMatchesActiveArea(entry, activeAreas)) {
				return;
			}

			const result = consumeEntry(workingQuery, entry);

			if (!result.matched) return;

			workingQuery = result.query;
			matchedEntries.push(entry);

			const clause = buildSearchClause(entry.search);

			if (clause) {
				clauses.push(clause);
			}
		});

		const unknownWords = removeStopWords(workingQuery);
		const strictSingle = matchedEntries.some(
			entry => entry.strict_single === true
		);
		const personalizationStrict = matchedPersonalizationEntries.some(
			entry => entry.strict_single === true
		);
		/*
		 * Sobald eine Produktart sicher erkannt wurde, bleiben wir bei dieser
		 * Produktart, auch wenn zusätzliche Wörter unbekannt oder für den
		 * erkannten Bereich unpassend sind.
		 *
		 * Dadurch werden z. B. "Butterdose klein", "Schüssel XXL" oder
		 * "Butterdose 18x14" nicht wieder zu einer breiten Shopify-Suche.
		 * Tippfehler wie "Linz Hantuch" bleiben weiterhin im normalen Fallback,
		 * weil dabei keine Produktart sicher erkannt wird.
		 */
		const hasReliableKnownContext =
			matchedContextKinds.has('product') &&
			matchedProductEntries.length > 0;

		/*
		 * PERSONALISIERUNGS-SPEZIALMODUS
		 */
		if (
			personalizationStrict &&
			personalizationClauses.length
		) {
			return {
				visible_query: visibleQuery,
				shopify_query: personalizationClauses.join(' AND '),
				filters: filters,
				mode: 'personalization'
			};
		}

		/*
		 * Bei gleichzeitig eindeutigem Textil- und Keramik-Kontext lieber normal suchen.
		 */
		if (activeAreas.size > 1) {
			let normalQuery = visibleQuery;

			if (matchedFilterEntries.length) {
				normalQuery = removeEntriesFromVisibleQuery(
					normalQuery,
					matchedFilterEntries
				);
			}

			if (!normalQuery) {
				normalQuery = 'title:*';
			}

			return {
				visible_query: visibleQuery,
				shopify_query: normalQuery,
				filters: filters,
				mode: 'normal'
			};
		}

		/*
		 * Unbekannte Wörter führen nur dann zur normalen Shopify-Suche, wenn
		 * keine Produktart sicher erkannt wurde. Eine sicher erkannte Produktart
		 * bleibt als harte Einschränkung bestehen; unpassende Zusatzwörter werden
		 * in diesem Fall ignoriert.
		 *
		 * Beispiele:
		 * - "Handtuch Bananen gelb" -> Handtuch + Gelb bleibt strikt
		 * - "Butterdose klein" -> Butterdose bleibt strikt, "klein" wird ignoriert
		 * - "Schüssel XXL" -> Schüssel bleibt strikt, XXL wird ignoriert
		 * - "Butterdose 18x14" -> Butterdose bleibt strikt, unbekannte Größe wird ignoriert
		 * - "Linz Hantuch" -> bleibt normale Suche + Serienfilter Linz
		 * - "Saunhandtuch grün" -> bleibt normale Suche (Tippfehler nicht raten)
		 */
		if (unknownWords && !hasReliableKnownContext) {
			let normalQuery = visibleQuery;

			if (matchedFilterEntries.length) {
				normalQuery = removeEntriesFromVisibleQuery(
					normalQuery,
					matchedFilterEntries
				);
			}

			if (!normalQuery) {
				normalQuery = 'title:*';
			}

			return {
				visible_query: visibleQuery,
				shopify_query: normalQuery,
				filters: filters,
				mode: 'normal'
			};
		}

		const shouldUseStrictSearch =
			(clauses.length || filters.length) &&
			(
				strictSingle ||
				matchedProductEntries.length > 0
			);

		if (shouldUseStrictSearch) {
			return {
				visible_query: visibleQuery,
				shopify_query: clauses.length
					? clauses.join(' AND ')
					: 'title:*',
				filters: filters,
				mode: 'strict'
			};
		}

		return {
			visible_query: visibleQuery,
			shopify_query: visibleQuery,
			filters: filters,
			mode: 'normal'
		};
	}

	function looksTechnical(query) {
		return (
			/(^|\s)(title|tag|vendor|product_type):/i.test(query) ||
			/\s+(AND|OR)\s+/i.test(query)
		);
	}

	function clearGeneratedFields(form) {
		form.querySelectorAll('[data-lashuma-generated]').forEach(input => {
			input.remove();
		});
	}

	function applyGeneratedFields(form, result) {
		clearGeneratedFields(form);

		if (!result.filters || !result.filters.length) {
			return;
		}

		const typeInput = document.createElement('input');
		typeInput.type = 'hidden';
		typeInput.name = 'type';
		typeInput.value = 'product';
		typeInput.setAttribute('data-lashuma-generated', '');
		form.appendChild(typeInput);

		result.filters.forEach(filter => {
			filter.values.forEach(value => {
				const filterInput = document.createElement('input');
				filterInput.type = 'hidden';
				filterInput.name = filter.name;
				filterInput.value = value;
				filterInput.setAttribute('data-lashuma-generated', '');
				form.appendChild(filterInput);
			});
		});
	}

	function buildSearchSignature(result) {
		const values = [
			['q', result.shopify_query]
		];

		if (result.filters && result.filters.length) {
			values.push(['type', 'product']);

			result.filters.forEach(filter => {
				filter.values.forEach(value => {
					values.push([filter.name, value]);
				});
			});
		}

		return JSON.stringify(
			values.sort((a, b) => {
				const keyCompare = a[0].localeCompare(b[0]);

				if (keyCompare !== 0) return keyCompare;

				return a[1].localeCompare(b[1]);
			})
		);
	}

	function getCurrentSearchSignature() {
		const params = new URLSearchParams(window.location.search);
		const values = [];

		params.forEach((value, key) => {
			if (
				key === 'q' ||
				key === 'type' ||
				key.startsWith('filter.')
			) {
				values.push([key, value]);
			}
		});

		return JSON.stringify(
			values.sort((a, b) => {
				const keyCompare = a[0].localeCompare(b[0]);

				if (keyCompare !== 0) return keyCompare;

				return a[1].localeCompare(b[1]);
			})
		);
	}

	function getVisibleQueryForCurrentPage() {
		const params = new URLSearchParams(window.location.search);
		const currentQuery = params.get('q') || '';

		if (!currentQuery) {
			return '';
		}

		const storedVisibleQuery = sessionStorage.getItem('lashuma_search_visible') || '';
		const storedSignature = sessionStorage.getItem('lashuma_search_signature') || '';
		const currentSignature = getCurrentSearchSignature();

		if (
			storedVisibleQuery &&
			storedSignature &&
			storedSignature === currentSignature
		) {
			return storedVisibleQuery;
		}

		/*
		 * Eine normale, nicht-technische q-Suche darf angezeigt werden.
		 * Eine technische title:/AND/OR-Abfrage wird NIEMALS ins sichtbare Feld geschrieben.
		 */
		if (!looksTechnical(currentQuery)) {
			return currentQuery;
		}

		return '';
	}

	function updateVisibleInputs() {
		const visibleQuery = getVisibleQueryForCurrentPage();

		document.querySelectorAll('[data-search-visible]').forEach(input => {
			input.value = visibleQuery;
		});

		document.querySelectorAll('[data-search-results-description]').forEach(element => {
			if (!visibleQuery) {
				element.style.visibility = 'hidden';
				return;
			}

			const placeholder = '__LASHUMA_SEARCH_QUERY__';

			if (element.textContent.includes(placeholder)) {
				element.textContent = element.textContent.replace(
					placeholder,
					visibleQuery
				);
			}

			element.style.visibility = '';
		});
	}

	document.addEventListener('submit', async function(event) {
		const form = event.target;

		if (!(form instanceof HTMLFormElement)) return;

		const visibleInput = form.querySelector('[data-search-visible]');
		const shopifyInput = form.querySelector('[data-search-shopify]');

		if (!visibleInput || !shopifyInput) return;

		event.preventDefault();

		await lexiconPromise;

		const result = analyseSearchQuery(visibleInput.value);

		if (!result.visible_query) {
			return;
		}

		shopifyInput.value = result.shopify_query;
		applyGeneratedFields(form, result);

		sessionStorage.setItem(
			'lashuma_search_visible',
			result.visible_query
		);

		sessionStorage.setItem(
			'lashuma_search_signature',
			buildSearchSignature(result)
		);

		HTMLFormElement.prototype.submit.call(form);
	}, true);

	updateVisibleInputs();

	window.LashumaSearch = {
		get catalog() {
			return LASHUMA_SEARCH_CATALOG;
		},
		get colorSource() {
			return DYNAMIC_COLOR_SOURCE;
		},
		analyse: analyseSearchQuery,
		ready: lexiconPromise
	};
})();
